<template>
  <div class="customize-line-group">
    <div class="line"><slot name="line"></slot></div>
    <div class="extra"><slot name="extra"></slot></div>
  </div>
</template>

<script>
export default _extend({
  name: 'CustomizeLineGroup'
});
</script>

<style lang="scss" scoped>
.customize-line-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  .line {
    flex: 1 1 auto;
    margin-right: 14px;
  }
  .extra {
    flex: 0 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewComponents/CustomizeLineGroup/CustomizeLineGroup.vue